module.exports = __webpack_public_path__ + "img/9_25.beced9aa.png";